import { isValid } from 'date-fns';

import { parseDateKey } from './format-date-key';

export type EventBoundaryPair = {
  start: Date | null;
  end: Date | null;
  // an absent boundary is an older backend, not a broken one — only a present-but-unreadable value counts
  isUnparseable: boolean;
};

// `new Date('yyyy-MM-dd')` parses as UTC midnight, landing on the previous local day west of UTC.
// null rather than an Invalid Date: the latter travels silently until date-fns `format` throws it
// inside a render, which takes the whole route down.
export const parseEventBoundary = (
  value: string,
  allDay: boolean,
): Date | null => {
  const date = allDay ? parseDateKey(value) : new Date(value);
  return isValid(date) ? date : null;
};

export const parseEventBoundaryPair = (
  start: string | undefined,
  end: string | undefined,
  allDay: boolean,
): EventBoundaryPair => {
  const parsedStart = start ? parseEventBoundary(start, allDay) : null;
  const parsedEnd = end ? parseEventBoundary(end, allDay) : null;

  return {
    start: parsedStart,
    end: parsedEnd,
    isUnparseable: (!!start && !parsedStart) || (!!end && !parsedEnd),
  };
};
